const en = {
  DATE_FORMAT: "MM/DD/YYYY",
  TIME_FORMAT: "h:mm A",
  NOON: "Noon"
};
export {
  en as default
};
//# sourceMappingURL=en.es.js.map
